<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="名称：" prop="name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="图片：" prop="imgpath" class="tipsitem">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload">
                    <img v-if="model.imgpath" :src="model.imgpath" class="upImg" style="width: 375px;height: 159px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 375px;height: 159px;line-height: 159px"></i>
                </el-upload>
                <span class="tips">建议尺寸：750px * 318px</span>
            </el-form-item>
            <el-form-item label="跳转地址：" prop="pagepath">
                <el-input v-model="model.pagepath"></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <el-input v-model.number="model.order_index"></el-input>
            </el-form-item>
            <el-form-item label="是否显示：" prop="isshow">
                <el-select clearable v-model="model.isshow" placeholder="请选择">
                    <el-option v-for="item in enuObj('yesNo')" :key="'yesNo'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import config from '@/config'
import { saveModel } from '@/api/common'

export default {
    name: "bannerEdit",
    mixins: [editutil],
    data() {
        return {
            model: {
                name: '',
                imgpath: '',
                pagepath: '',
                order_index: '',
                isshow: '1'
            },
            getObj:{
                url:'/api/admin/banner/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['yesNo'],
            rules: {
                name: [
                    {required: true, message: '名称不能为空', trigger: 'blur'}
                ],
                imgpath: [
                    {required: true, message: '图片不能为空', trigger: 'blur'}
                ],
                order_index: [
                    {required: true, message: '排序不能为空', trigger: 'blur'},
                    {type: 'number', message: '排序必须是数字值', trigger: 'blur'}
                ],
                isshow: [
                    {required: true, message: '是否显示不能为空', trigger: 'blur'},
                ]
            },
            uploadAction: config.uploadAction,
            uploadData: {
                folder: "banner",
            },
        }
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/banner/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        handleUploadSuccess(res, file){
            if(res.code ==1){
                this.model.imgpath = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        formateData(){
            this.model.isshow = this.model.isshow+""
        }
    }
};
</script>